import { useEffect } from 'react'
import { heartBeat } from '@/api/auth.api'
import { pb } from '@/utils/pb'

export function useHeartbeat(intervalMs: number = 30_000) {
  useEffect(() => {
    const intervalId = window.setInterval(async () => {
      // Avoid spamming the backend when the user is logged out.
      if (!pb.authStore?.isValid) return

      try {
        await heartBeat()
      } catch {
        // Heartbeat failures should not break the app UX.
      }
    }, intervalMs)

    return () => window.clearInterval(intervalId)
  }, [intervalMs])
}
